import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenDropdown(null);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  return (
    <header className="header">
      <div className="header-top">
        <Link to="/" className="logo-section" onClick={closeMenu}>
          <img
            src="/image/hplogo2.png"
            alt="iHariPrabodham Logo"
            className="logo-img"
          />
          <div className="logo-text">
            <h1>HariPrabodham</h1>
            <p className="tagline">He Hari, Bas Ek Tu Raji Tha!!!</p>
          </div>
        </Link>
        <button
          className={`hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
      <nav className={`navbar ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-menu">
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>

          <li
            className={`dropdown ${openDropdown === "pravachan" ? "active" : ""}`}
          >
            <span
              className="dropdown-toggle"
              onClick={() => toggleDropdown("pravachan")}
            >
              Pravachan ▾
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/pravachan/hari-paramrut" onClick={closeMenu}>
                  Hari Paramrut
                </Link>
              </li>
              <li>
                <Link to="/pravachan/akshar-vani" onClick={closeMenu}>
                  Akshar Vani
                </Link>
              </li>
              <li>
                <Link to="/pravachan/akshar-vani-two" onClick={closeMenu}>
                  Akshar Vani Two
                </Link>
              </li>
              <li>
                <Link to="/pravachan/akshar-vani-search" onClick={closeMenu}>
                  Akshar Vani Search
                </Link>
              </li>
              <li>
                <Link to="/pravachan/mara-swamiji" onClick={closeMenu}>
                  Mara Swamiji
                </Link>
              </li>
              <li>
                <Link to="/pravachan/sant-vani" onClick={closeMenu}>
                  Sant Vani
                </Link>
              </li>
              <li>
                <Link to="/pravachan/sant-vani-two" onClick={closeMenu}>
                  Sant Vani Two
                </Link>
              </li>
              <li>
                <Link to="/pravachan/mara-guruhari" onClick={closeMenu}>
                  Mara Guruhari
                </Link>
              </li>
              <li>
                <Link to="/pravachan/baheno-pravachan" onClick={closeMenu}>
                  Baheno Pravachan & Smruti
                </Link>
              </li>
              <li>
                <Link to="/pravachan/usa-yatra" onClick={closeMenu}>
                  USA Yatra
                </Link>
              </li>
              <li>
                <Link to="/pravachan/canada-yatra" onClick={closeMenu}>
                  Canada Yatra
                </Link>
              </li>
              <li>
                <Link to="/pravachan/europe-yatra" onClick={closeMenu}>
                  Europe Yatra
                </Link>
              </li>
              <li>
                <Link to="/pravachan/vakta" onClick={closeMenu}>
                  Vakta
                </Link>
              </li>
              <li>
                <Link to="/pravachan/sevak-pravachan" onClick={closeMenu}>
                  Sevak Pravachan
                </Link>
              </li>
              <li>
                <Link to="/pravachan/haribhakt-pravachan" onClick={closeMenu}>
                  Haribhakt Pravachan
                </Link>
              </li>
            </ul>
          </li>
          <li
            className={`dropdown ${openDropdown === "darshan" ? "active" : ""}`}
          >
            <span
              className="dropdown-toggle"
              onClick={() => toggleDropdown("darshan")}
            >
              Darshan ▾
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/darshan/sahaj" onClick={closeMenu}>
                  Sahaj Darshan
                </Link>
              </li>
              <li>
                <Link to="/pravachan/shorts" onClick={closeMenu}>
                  Shorts
                </Link>
              </li>

              <li>
                <Link to="/pravachan/shorts-two" onClick={closeMenu}>
                  Shorts Two
                </Link>
              </li>

              <li>
                <Link to="/darshan/highlight" onClick={closeMenu}>
                  Utsav HighLight
                </Link>
              </li>

              <li>
                <Link to="/darshan/seva-bhakti" onClick={closeMenu}>
                  Seva Bhakti
                </Link>
              </li>
              <li>
                <Link to="/darshan/samvad-and-nrutya" onClick={closeMenu}>
                  Samvad And Nrutya
                </Link>
              </li>
              <li>
                <Link to="/pravachan/transformation" onClick={closeMenu}>
                  Transformation
                </Link>
              </li>
              <li>
                <Link to="/pravachan/guest" onClick={closeMenu}>
                  Mahanubhavo
                </Link>
              </li>

              <li>
                <Link to="/darshan/social-activity" onClick={closeMenu}>
                  Social Activity
                </Link>
              </li>
              <li>
                <Link to="/darshan/desh-bhakti" onClick={closeMenu}>
                  Desh Bhakti
                </Link>
              </li>
            </ul>
          </li>
          <li
            className={`dropdown ${openDropdown === "vicharan" ? "active" : ""}`}
          >
            <span
              className="dropdown-toggle"
              onClick={() => toggleDropdown("vicharan")}
            >
              Guruhari Darshan ▾
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/vicharan-darshan" onClick={closeMenu}>
                  Vicharan Darshan
                </Link>
              </li>

              <li>
                <a
                  href="https://smruti.ihariprabodham.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMenu}
                >
                  Smruti Darshan
                </a>
              </li>

              <li>
                <Link to="/darshan/pooja" onClick={closeMenu}>
                  Pooja Darshan
                </Link>
              </li>
              <li>
                <Link to="/darshan/pragatya" onClick={closeMenu}>
                  Pragatya Parv
                </Link>
              </li>
              <li>
                <Link to="/vicharan-map" onClick={closeMenu}>
                  Vicharan Map
                </Link>
              </li>
              <li>
                <Link to="/pradesh-map" onClick={closeMenu}>
                  Pradesh Map
                </Link>
              </li>
              <li>
                <Link to="/calendar2026" onClick={closeMenu}>
                  Calendar 2026
                </Link>
              </li>
              <li>
                <Link to="/smrutimap" onClick={closeMenu}>
                  Smruti Map
                </Link>
              </li>
              <li>
                <Link to="/prabodham-prasangam" onClick={closeMenu}>
                  Prabodham Prasangam
                </Link>
              </li>
              <li>
                <Link to="/darshan/jivan-darshan" onClick={closeMenu}>
                  Jivan Darshan
                </Link>
              </li>
            </ul>
          </li>
          <li
            className={`dropdown ${openDropdown === "HariKaruna" ? "active" : ""}`}
          >
            <span
              className="dropdown-toggle"
              onClick={() => toggleDropdown("HariKaruna")}
            >
              Hari Karuna ▾
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/asoj-map" onClick={closeMenu}>
                  Parabhu Bal Charitam
                </Link>
              </li>
              <li>
                <Link to="/pravachan/mara-swamiji" onClick={closeMenu}>
                  Mara Swamiji
                </Link>
              </li>
              <li>
                <Link to="/pravachan/hari-paramrut" onClick={closeMenu}>
                  Hari Paramrut
                </Link>
              </li>
              <li>
                <Link to="/pravachan/hari-paramrut-three" onClick={closeMenu}>
                  Hari Paramrut (10 Min)
                </Link>
              </li>
              {/* <li>
                <Link to="/pravachan/hari-paramrut-four" onClick={closeMenu}>
                  Hari Paramrut 2
                </Link>
              </li> */}
              <li>
                <Link to="/pravachan/hari-prasangam" onClick={closeMenu}>
                  Hari Prasangam
                </Link>
              </li>
              <li>
                <Link to="/granth/bhede-sakshi-anant" onClick={closeMenu}>
                  Bhede Sakshi Anantna
                </Link>
              </li>
              <li>
                <Link to="/darshan/hari-prasang-darshan" onClick={closeMenu}>
                  Hari Smruti Video
                </Link>
              </li>
              <li>
                <a
                  href="https://smruti.ihariprabodham.in/smrutimonth.php?year=PPHariprasadSwamiji"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMenu}
                >
                  Hari Smruti
                </a>
              </li>

              <li>
                <Link to="/granth/anirdeshi-amrut" onClick={closeMenu}>
                  Anirdeshi Amrut
                </Link>
              </li>
              <li>
                <Link to="/granth/ambrish-upnishad" onClick={closeMenu}>
                  Ambrish Upnishad
                </Link>
              </li>
              <li>
                <Link to="/pravachan/gururun-ada-kariye" onClick={closeMenu}>
                  Gururoon Ada Kariye
                </Link>
              </li>
              <li>
                <Link to="/pravachan/hariroon-ada-kariye" onClick={closeMenu}>
                  Hariroon Ada Kariye
                </Link>
              </li>
              <li>
                <Link to="/pravachan/saras-ek-sahajanand" onClick={closeMenu}>
                  Saras Ek Sahajanand
                </Link>
              </li>
            </ul>
          </li>

          <li
            className={`dropdown ${openDropdown === "granth" ? "active" : ""}`}
          >
            <span
              className="dropdown-toggle"
              onClick={() => toggleDropdown("granth")}
            >
              Granth ▾
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/granth/shikshapatri" onClick={closeMenu}>
                  Shikshapatri
                </Link>
              </li>
              <li>
                <Link to="/granth/shikshapatri-mukhpath" onClick={closeMenu}>
                  Shikshapatri Mukhpath
                </Link>
              </li>
              <li>
                <Link to="/granth/vachanamrut" onClick={closeMenu}>
                  Vachanamrut
                </Link>
              </li>
              <li>
                <Link to="/granth/swamini-vato" onClick={closeMenu}>
                  Swamini Vato
                </Link>
              </li>
              <li>
                <Link to="/granth/anirdeshi-amrut" onClick={closeMenu}>
                  Anirdeshi Amrut
                </Link>
              </li>
              <li>
                <Link to="/granth/ambrish-upnishad" onClick={closeMenu}>
                  Ambrish Upnishad
                </Link>
              </li>
              <li>
                <Link to="/granth/bhede-sakshi-anant" onClick={closeMenu}>
                  Bhede Sakshi Anantna
                </Link>
              </li>
              <li>
                <Link to="/pravachan/hari-prasangam" onClick={closeMenu}>
                  Hari Prasangam
                </Link>
              </li>
              <li>
                <Link to="/prabodham-prasangam" onClick={closeMenu}>
                  Prabodham Prasangam
                </Link>
              </li>

              <li>
                <Link to="/granth/kirtan" onClick={closeMenu}>
                  Kirtan
                </Link>
              </li>
              <li>
                <Link to="/granth/brahm-ratna" onClick={closeMenu}>
                  Brahm Ratna
                </Link>
              </li>
              <li>
                <Link to="/granth/search-word" onClick={closeMenu}>
                  Search Word
                </Link>
              </li>
            </ul>
          </li>
          <li
            className={`dropdown ${openDropdown === "download" ? "active" : ""}`}
          >
            <span
              className="dropdown-toggle"
              onClick={() => toggleDropdown("download")}
            >
              Download ▾
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/download/wallpaper" onClick={closeMenu}>
                  Wallpaper
                </Link>
              </li>
              <li>
                <Link to="/download/desktop-wallpaper" onClick={closeMenu}>
                  Desktop Wallpaper
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/parampara" onClick={closeMenu}>
              Parampara
            </Link>
          </li>
          <li>
            <Link to="/whats-new" onClick={closeMenu}>
              What's New
            </Link>
          </li>

          <li>
            <a
              href="https://ihariprabodham.org/MariSmruti/login"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Mari Smruti
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
